<div class="kt-portlet">
	<div class="kt-portlet__head">
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">Bulk Action</h3>
		</div>
	</div>
	<div class="kt-portlet__body">


		<mat-horizontal-stepper [linear]="true" labelPosition="bottom" #stepper>
			<mat-step [completed]="selection.selected.length > 0">

				<ng-template matStepLabel>Select machines</ng-template>

				<div class="filters-container">
					<div class="hierarchical-filters-row">
						<kt-hierarchical-filters
							[role]="role"
							[showDistributor]="role == 'sadmin'"
							[showMarket]="role == 'sadmin' || role == 'distiadmin'"
							[showClient]="role == 'sadmin' || role == 'distiadmin'"
							[showCampus]="role == 'sadmin' || role == 'distiadmin' || role == 'clientadmin'"
							[multiple]="false"
							(filterChange)="onFiltersChange($event)">
						</kt-hierarchical-filters>
					</div>

					<div *ngIf="role == 'sadmin' || role == 'distiadmin' || role == 'clientadmin'" class="hierarchical-filters hierarchical-filters-row">
						<div class="scope-select-wrapper">
							<label class="scope-select-label">Select S/W type</label>
							<kt-searchable-select
								[options]="versionTypeOptions"
								[multiple]="false"
								[searchable]="false"
								[(ngModel)]="selType"
								(selectionChange)="onType()">
							</kt-searchable-select>
						</div>
						<div class="scope-select-wrapper">
							<label class="scope-select-label">Select S/W version</label>
							<kt-searchable-select
								[options]="versionOptions"
								[multiple]="false"
								[searchable]="false"
								[(ngModel)]="selVersion"
								(selectionChange)="onVersion()">
							</kt-searchable-select>
						</div>
					</div>
				</div>

				<!-- <ng-template matStepLabel>Select machines</ng-template>
				<mat-form-field>
					<mat-label>Select Machine Type</mat-label>
					<mat-select [(value)]="macType" (selectionChange)="onMacType()">
						<mat-option [value]="''">All</mat-option>
					  	<mat-option value="tcn">TCN</mat-option>
						<mat-option value="locker">Locker</mat-option>
						<mat-option value="wit">Wittern</mat-option>
					</mat-select>
				</mat-form-field>
				&nbsp;
				<ng-template matStepLabel>Select machines</ng-template>
				<mat-form-field>
					<mat-label>Select Region</mat-label>
					<mat-select [(value)]="selRegion" (selectionChange)="onRegion()">
						<mat-option [value]="''">All</mat-option>
					  	<mat-option *ngFor="let region of regions" [value]="region.region_id">{{region.region}}</mat-option>
					</mat-select>
				</mat-form-field>
				&nbsp;
				<mat-form-field>
					<mat-label>Select Territory</mat-label>
					<mat-select [(value)]="selTerritory" (selectionChange)="onTerritory()">
						<mat-option [value]="''">All</mat-option>
					  	<mat-option *ngFor="let territory of territories" [value]="territory.territory_id">{{territory.territory}}</mat-option>
					</mat-select>
				</mat-form-field>
				&nbsp;
				<mat-form-field>
					<mat-label>Select S/W type</mat-label>
					<mat-select [(value)]="selType" (selectionChange)="onType()">
						<mat-option [value]="''">All</mat-option>
						<mat-option *ngFor="let vt of versionTypes" [value]="vt.value">{{vt.key}}</mat-option>
					  </mat-select>
				</mat-form-field> :
				<mat-form-field>
					<mat-label>Select S/W version</mat-label>
					<mat-select [(value)]="selVersion" (selectionChange)="onVersion()">
						<mat-option [value]="''">All</mat-option>
					  <mat-option *ngFor="let ver of versions" [value]="ver.file_version">{{ver.file_version}}</mat-option>
					</mat-select>
				</mat-form-field> -->

				<div class="row justify-content-end">
					<div class="col-md-auto kt-margin-bottom-10-mobile ml-3">
						<div class="kt-form__control text-right">
							<button type="button" (click)="exportExcel()" class="btn btn-success">
								Export Report
							</button>
						</div>
					</div>
					<!-- <div class="col-md-auto kt-form__control text-right">
						<button mat-icon-button [matMenuTriggerFor]="settingsMenu" class="mr-3" #menuTrigger="matMenuTrigger">
						  <mat-icon>settings</mat-icon>
						</button>
						<mat-menu #settingsMenu="matMenu">
						  <ng-template matMenuContent>
							<div *ngFor="let col of availableColumns">
							  <mat-checkbox appMenuCheckboxTrigger [checked]="columnVisibility[col.value]" (change)="toggleColumnVisibility(col)">
								{{ col.key }}
							  </mat-checkbox>
							</div>
							<button mat-button (click)="applyChanges()">Apply Changes</button>
						  </ng-template>
						</mat-menu>
					  </div> -->




					<div class="col-md-auto kt-form__control text-right">
						<button mat-icon-button [matMenuTriggerFor]="settingsMenu" class="mr-3">
							<mat-icon>settings</mat-icon>
						</button>
						<mat-menu #settingsMenu="matMenu">
							<ng-template matMenuContent>
								<div *ngFor="let col of availableColumns" (click) = "$event.stopPropagation()">
									<mat-checkbox [checked]="columnVisibility[col.value]" (change)="toggleColumnVisibility(col)">
										{{ col.key }}
									  </mat-checkbox>
								</div>
							</ng-template>
						</mat-menu>
					</div>
				</div>


				<!-- <button mat-icon-button [matMenuTriggerFor]="settingsMenu">
					<mat-icon>settings</mat-icon>
				</button>

				<mat-menu #settingsMenu="matMenu">
					<ng-template matMenuContent>
					  <div *ngFor="let col of availableColumns">
						<mat-checkbox [(ngModel)]="columnVisibility[col]" (change)="toggleColumnVisibility(col)">
						  {{ col }}
						</mat-checkbox>
					  </div>
					</ng-template>
				  </mat-menu>

				  <div class="row mt-5">
					<button type="button" (click)="exportExcel('excel-table','ver-report')" class="btn btn-success mr-3 ml-auto">Export Report</button>
				  </div> -->


				<table id="excel-table" *ngIf="machines" mat-table [dataSource]="dataSource" style="width: 100%;" class="mat-elevation-z0">

					<!-- <ng-container matColumnDef="select">
					  <th mat-header-cell *matHeaderCellDef>
						<mat-checkbox (change)="$event ? masterToggle() : null"
									  [checked]="selection.hasValue() && isAllSelected()"
									  [indeterminate]="selection.hasValue() && !isAllSelected()"
									  [aria-label]="checkboxLabel()">
						</mat-checkbox>
					  </th>
					  <td mat-cell *matCellDef="let row">
						<mat-checkbox (click)="$event.stopPropagation()"
									  (change)="$event ? selection.toggle(row) : null"
									  [checked]="selection.isSelected(row)"
									  [aria-label]="checkboxLabel(row)">
						</mat-checkbox>
					  </td>
					</ng-container> -->
					<!-- <ng-container [matColumnDef]="col" *ngFor="let col of displayedColumns">
						<ng-container *ngIf="col !== 'select'">
						  <th mat-header-cell *matHeaderCellDef>{{ col | titlecase }}</th>
						  <td mat-cell *matCellDef="let element">{{ element[col] }}</td>
						</ng-container>
					  </ng-container> -->

					<ng-container matColumnDef="select">
						<th mat-header-cell *matHeaderCellDef>
						  <mat-checkbox  (change)="$event ? masterToggle($event) : null" [checked]="selection.hasValue() && isAllSelected() == true" [indeterminate]="selection.hasValue() && !isAllSelected()">
						  </mat-checkbox>
						</th>
						<td mat-cell *matCellDef="let row">
						  <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectRow($event, row) : null" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row) == true">
						  </mat-checkbox>
						</td>
					</ng-container>


					<ng-container matColumnDef="machine_name">
					  <th mat-header-cell *matHeaderCellDef> Machine Name </th>
					  <td mat-cell *matCellDef="let element"> {{element.machine_name}} </td>
					</ng-container>

					<ng-container matColumnDef="machine_id">
					  <th mat-header-cell *matHeaderCellDef> Machine ID </th>
					  <td mat-cell *matCellDef="let element"> {{element.machine_id}} </td>
					</ng-container>

					<ng-container matColumnDef="ui_cv">
					<th mat-header-cell *matHeaderCellDef > UI CV </th>
					<td mat-cell *matCellDef="let element"> {{element.ui_cv}} </td>
					</ng-container>

					<ng-container matColumnDef="ui_av">
					<th mat-header-cell *matHeaderCellDef> UI AV </th>
					<td mat-cell *matCellDef="let element"> {{element.ui_av}} </td>
					</ng-container>

					<ng-container matColumnDef="aux_cv">
						<th mat-header-cell *matHeaderCellDef> AUX CV </th>
						<td mat-cell *matCellDef="let element"> {{element.aux_cv}} </td>
					  </ng-container>

					<ng-container matColumnDef="aux_av">
						<th mat-header-cell *matHeaderCellDef> AUX AV</th>
						<td mat-cell *matCellDef="let element"> {{element.aux_av}} </td>
					</ng-container>

					<ng-container matColumnDef="menu_cv">
						<th mat-header-cell *matHeaderCellDef> MENU CV </th>
						<td mat-cell *matCellDef="let element"> {{element.menu_cv}} </td>
					  </ng-container>

					<ng-container matColumnDef="menu_av">
						<th mat-header-cell *matHeaderCellDef> MENU AV</th>
						<td mat-cell *matCellDef="let element"> {{element.menu_av}} </td>
					</ng-container>



					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns;"
						(click)="selection.toggle(row)">
					</tr>

				  </table>
				  <mat-paginator [pageSizeOptions]="[50, 100, 150]" showFirstLastButtons></mat-paginator>

				<div class="row mt-3">
				  <button class="ml-auto mr-3" color="primary" (click)="onNext()" [disabled]="selection.selected.length === 0" mat-raised-button matStepperNext>Next</button>
				</div>
			</mat-step>
			<mat-step>
				<ng-template matStepLabel>Action</ng-template>
				<p class="text-dark text-center">Total machines selected: <span class="text-primary font-weight-bold">{{selection.selected.length}}</span></p>
				<div class="hierarchical-filters">
					<div class="scope-select-wrapper">
						<label class="scope-select-label">Select an action</label>
						<kt-searchable-select
							[options]="actionOptions"
							[multiple]="false"
							[searchable]="false"
							[(ngModel)]="opt"
							(selectionChange)="onOpt($event)">
						</kt-searchable-select>
					</div>
				</div>
				<br class="mb-5">
				<!-- <div *ngIf="!opt" class="row mt-3">
					<h5 class="text-center mx-auto">Please select one from the below options</h5>
				</div>

				<div *ngIf="!opt" class="row mt-5">
					<div class="col-xl-6">
						<div (click)="onOpt('update')" class="card p-3 m-3 pointer">
							<h6>Update Software & Firmware</h6>
							<hr>
							<p>Lets you update Software and firmware versions for more than one machine at the same time.</p>
						</div>
					</div>
					<div class="col-xl-6">
						<div (click)="onOpt('category')" class="card p-3 m-3 pointer">
							<h6>Update Machine Category</h6>
							<hr>
							<p>Lets you update machine type and status for more than one machine at the same time.</p>
						</div>
					</div>
				</div>
				<div *ngIf="!opt" class="row mt-3">
					<button mat-raised-button class="mr-auto ml--+*93" color="warn" matStepperPrevious>Back</button>
					<button mat-raised-button class="ml-auto mr-3" color="primary" (click)="stepper.reset()">Reset</button>
				</div> -->
				<kt-sw-update *ngIf="opt === 'update'" [mList]="selection.selected" [macType]="macType"></kt-sw-update>
				<kt-machine-category *ngIf="opt === 'category'" [mList]="selection.selected" [stepperObj]="stepper"></kt-machine-category>
			</mat-step>
		  </mat-horizontal-stepper>

	</div>
</div>
